import React from 'react';
import { Stack, Typography } from '@mui/material';
import IconGraphic from '../icons/IconGraphic';
import InputCurrency from '@/components/Base/InputCurrency.tsx';

type PropsType = {
  title: string;
  value?: string;
  percentage?: string | number;
  formik?: any;
  field?: string;
  status?: 'down' | 'up';
};
const KpiComponentGreen: React.FC<PropsType> = ({ title, value, percentage, formik, field, status }) => {

  const colorStatus = {
    'up': { background: 'rgba(35, 193, 10, 0.15)', color: 'rgba(11, 138, 0, 1)' },
    'down': { background: '#DF4A4C', color: '#FFF' },
  }

  return (
    <Stack
      position={'relative'}
      minWidth={'225px'}
      minHeight={'111px'}
      p={'16px'}
      borderRadius={'6px'}
      sx={{ border: '2px solid rgba(236, 238, 246, 1)', width: '100%' ,
        background: '#15AB51',
        color: '#fff ',
      }}
      maxWidth={'225px'}
      display={'flex'}
      justifyContent={'space-between'}
  
    >
      {!!percentage && (
        <div
          style={{
            fontSize: '14px',
            position: 'absolute',
            right: '5px',
      
            borderRadius: '50px',
            padding: '3px',
          }}
        >
          <IconGraphic sx={{ fontSize: '12px', marginRight: '3px' }} />
          {parseFloat(String(percentage)).toFixed(2)} %
        </div>
      )}
      <Typography  fontSize={'16px'} fontWeight={600} mb={1} maxWidth={'120px'}>
        {title}
      </Typography>
      {
        value && (
          <Typography  fontSize={'24px'} fontWeight={700}>
            {value}
          </Typography>
        )
      }

      {
        formik && (
          <InputCurrency
            id={field}
            name={field}
            required
            value={formik.values[field]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched[field] && !!formik.errors[field]}
            helperText={
              formik.touched[field] &&
              formik.errors[field] &&
              formik.errors[field]
            }
            sx={{
              '.MuiInputBase-input': {
                borderRadius: '8px',
                fontWeight: 'bold'
              },
            }}
          />
        )
      }
    </Stack>
  );
};

export default KpiComponentGreen;
